export default "__VITE_ASSET__Bv__v5LO__ 400w, __VITE_ASSET__CVTnAgeY__ 800w, __VITE_ASSET__Cqx6XSSn__ 1024w";